import { z } from 'zod';

/** 保存データの上限（docs/data-format/format-v1.md 1 章。暫定）。 */
export const LIMITS = {
  /** 1 コースあたりの制御点の最大数 */
  maxControlPoints: 5000,
  /** 1 プロジェクトあたりのコースの最大数 */
  maxCourses: 200,
  /** プロジェクトファイルの最大サイズ（バイト） */
  maxFileBytes: 10 * 1024 * 1024,
} as const;

/** 座標の絶対値の上限 [m]。これを超える値は編集ミスとして拒否する。 */
export const MAX_COORDINATE = 100_000;

/** 有限な数値。`NaN`・`Infinity` は JSON にも保存データにも持ち込まない。 */
export const finiteNumber = z.number().finite();

/** 位置・ベクトル `[x, y, z]`（SI 単位）。 */
export const vec3Schema = z.tuple([finiteNumber, finiteNumber, finiteNumber]);

/** 位置 `[x, y, z]` [m]。絶対値が {@link MAX_COORDINATE} 以下。 */
export const positionSchema = z.tuple([
  finiteNumber.min(-MAX_COORDINATE).max(MAX_COORDINATE),
  finiteNumber.min(-MAX_COORDINATE).max(MAX_COORDINATE),
  finiteNumber.min(-MAX_COORDINATE).max(MAX_COORDINATE),
]);

/**
 * 文書の ID。UUID、または組み込みテンプレートの `builtin:<名前>`（例：`builtin:vehicle/standard-steel`）。
 */
export const documentIdSchema = z.union([
  z.uuid(),
  z.string().regex(/^builtin:[a-z0-9][a-z0-9/_-]{0,63}$/, {
    message: 'UUID、または builtin:<名前> の形式で指定してください',
  }),
]);

/** ISO 8601（UTC）の日時文字列。 */
export const timestampSchema = z.iso.datetime();

/** 表示名（1〜100 文字）。 */
export const nameSchema = z.string().trim().min(1).max(100);

/** 説明文（最大 2,000 文字）。 */
export const descriptionSchema = z.string().max(2000);
